import React from 'react';
import PropTypes from 'prop-types';
import IntlTelInput from 'react-intl-tel-input';
import MediaQueries from 'react-responsive';

import 'react-intl-tel-input/dist/main.css';
import './telInput.css';

import FormInput from '../FormWrap/FormInput';
import { readCookie } from '../../../utils/params';
import { trackFormErrorsWithHeap } from '../../../utils/forms/validation';

let phoneValue = null;

export default function PhoneInput({
  input,
  placeholder,
  meta: { touched, error },
}) {
  const hasError = !!(touched && error);
  const reduxFormOnChange = input.onChange;
  const onChange = (validation, value, countryCode) => {
    // We want to track the value to transfer to heap if its invalid
    phoneValue = value;
    const cc = countryCode.dialCode;
    // we don't set the value until it's valid
    if (validation) {
      reduxFormOnChange(`+${cc}${value}`);
    } else {
      reduxFormOnChange('');
    }
  };

  let defaultCountry = readCookie('geo-country-code');
  if (defaultCountry == null) {
    defaultCountry = 'us';
  } else {
    defaultCountry = defaultCountry.toLowerCase();
  }

  if (hasError) {
    trackFormErrorsWithHeap('phoneField', phoneValue);
  }

  return (
    <div>
      <MediaQueries minWidth={720}>
        <IntlTelInput
          containerClassName={
            hasError ? 'intl-tel-input has-error' : 'intl-tel-input'
          }
          inputClassName={hasError ? 'form-control has-error' : 'form-control'}
          onPhoneNumberChange={onChange}
          onSelectFlag={(value, countryCode, _, validation) =>
            onChange(validation, value, countryCode)
          }
          defaultCountry={defaultCountry}
        />
      </MediaQueries>
      <MediaQueries maxWidth={721}>
        <FormInput
          placeholder={placeholder}
          meta={{ touched, error }}
          {...input}
        />
      </MediaQueries>
    </div>
  );
}

PhoneInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/EnterpriseForm/PhoneInput.js